/**
 * Created by Desarrollo KJ on 21/3/2017.
 */
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {Subject} from 'rxjs/Subject';
import {ToastyService} from 'ng2-toasty';


@Injectable()
export class FloatButtonCartService {
  private subject = new Subject<any>();

  constructor(private toasty: ToastyService) {

  }

  addToCart(idProducto: number, cantidad: number, alert: boolean = true) {
    if (localStorage.getItem('carrito')) {
      let array: any = JSON.parse(localStorage.getItem('carrito'));
      if (typeof array[idProducto] !== 'undefined') {
        array[idProducto] = parseInt(array[idProducto]) + cantidad;
      }
      else {
        array[idProducto] = cantidad;
      }

      localStorage.setItem('carrito', JSON.stringify(array));
    }
    else {
      let array = {};
      array[idProducto] = cantidad;
      localStorage.setItem('carrito', JSON.stringify(array))
    }
    if (alert) {
      this.toasty.success('Agregado al carrito con exito');
    }
    this.subject.next({emit: true});
  }

  subToCart(idProducto: number, cantidad: number, alert: boolean = true) {
    if (localStorage.getItem('carrito')) {
      let array: any = JSON.parse(localStorage.getItem('carrito'));
      if (array[idProducto] >= 2) {
        array[idProducto] = parseInt(array[idProducto]) - cantidad;
      }
      else {
        delete array[idProducto];
      }

      localStorage.setItem('carrito', JSON.stringify(array));
    }
    else {
      let array = {};
      localStorage.setItem('carrito', JSON.stringify(array))
    }
    if (alert) {
      this.toasty.success('Agregado al carrito con exito');
    }
    this.subject.next({emit: true});
  }

  remplaceToCart(idProducto: number, cantidad: number, alert: boolean = true) {
    if (localStorage.getItem('carrito')) {
      let array: any = JSON.parse(localStorage.getItem('carrito'));
      if (typeof array[idProducto] !== 'undefined') {
        array[idProducto] = cantidad;
      }
      else {
        array[idProducto] = cantidad;
      }

      localStorage.setItem('carrito', JSON.stringify(array));
    }
    else {
      let array = {};
      array[idProducto] = cantidad;
      localStorage.setItem('carrito', JSON.stringify(array))
    }
    if (alert) {
      this.toasty.success('Agregado al carrito con exito');
    }
    this.subject.next({emit: true});
  }

  deleteToCart(idProducto: number) {
    let array: any = JSON.parse(localStorage.getItem('carrito'));
    delete array[idProducto];
    localStorage.setItem('carrito', JSON.stringify(array));
    this.toasty.success('Eliminado del carrito con exito');
    this.subject.next({emit: true});
  }


  limpiarCart() {
    localStorage.removeItem('carrito');
    this.subject.next({emit: true});
  }

  getUpdate(): Observable<any> {
    return this.subject.asObservable();
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/floatButtonCart/floatButtonCart.service.ts